<div class="dialog-header" fxLayout="row" fxLayoutAlign="space-between center">
  <span class="title">Déclarer un ES</span>
  <button style="transform: translateX(10px);" mat-mini-fab color="accent" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form" fxLayout="column" fxLayoutGap="10px" fxFlex="1" (submit)="validateEs()">

  <mat-form-field>
    <mat-label>Type</mat-label>
    <mat-select [appFocusMe]="true" formControlName="idType" cdkFocusInitial (selectionChange)="getPgm()">
      <mat-option *ngFor="let item of esTypes" [value]="item.code">
        {{item.name}}
      </mat-option>
    </mat-select>
    <mat-hint>Sélectionner un type pour récupérer le PGM relié</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Préconisation</mat-label>
    <mat-select formControlName="idPreconisation">
      <mat-option *ngFor="let item of preconisations" [value]="item.code">
        {{item.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>PGM</mat-label>
    <input matInput [formControl]="descriptionPgmCtrl" type="text" readonly/>
    <mat-error *ngIf="descriptionPgmCtrl.invalid">
      Pgm introuvable, changer de type ou de segment.
    </mat-error>
  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-raised-button
            color="accent" type="button" (click)="updatePosition()">
      Changer de position
    </button>

    <button mat-raised-button
            color="accent"
            type="submit"
            [disabled]="form.invalid || form.pristine">
      Valider
    </button>
  </div>

</form>


